/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ERR_INVALID_URL, WEBHOOK_SECRET,WEBHOOK_SECRET_VALUE, WEBHOOK_NAME, WEBHOOK_URL, WEBHOOK_NAME_ERROR, WEBHOOK_NAME_INVALID, WEBHOOK_SECRET_KEY_INVALID, WEBHOOK_SECRET_VALUE_INVALID, LABEL_BTN_CANCEL, VERSION_PAYLOADS } from 'src/constants/constant';
import { InputAdornment, MenuItem, TextField } from '@mui/material';
import { getAllWebhookConfigById, updateWebhookConfig } from 'src/services/webhookconfigService';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';

import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useSelector } from 'react-redux';
import type { RootState, EditWebhookFormInputs } from '../types/types';
import { checkEventPermission } from 'src/common/utility/utility';

// import MainLayout from '../Layouts/Mainlayout';

interface PropsType {
    id?: number;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        data: EditWebhookFormInputs;
    };
}

interface EditApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}


const validationSchema = Yup.object().shape({
    webhookName: Yup.string().required(WEBHOOK_NAME_ERROR).matches(/^\S.*\S$|^\S$/, WEBHOOK_NAME_INVALID),
    url: Yup.string().required('Please enter the webhook URL').matches(
            /^((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm,
            ERR_INVALID_URL
        ),
    version: Yup.string().required('Please select the webhook version'),
    SecretKey: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_KEY_INVALID),
    SecretValue: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_VALUE_INVALID),
});


const EditWebhookForm = ({ id, closeModal, refreshPage }: PropsType): JSX.Element => {

    const [webhookData, setWebhookData] = useState<EditWebhookFormInputs>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const [isEditing, setIsEditing] = useState(false);
    const [includeTestData, setIncludeTestData] = useState<boolean>(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm<EditWebhookFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    const version = watch('version');

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const fetchWebhookData = async () => {
            try {
                const editWebhookIdNumber = id;
                if (editWebhookIdNumber == null) return;
                setIsLoading(true)
                const res: ApiResponse = await getAllWebhookConfigById(editWebhookIdNumber);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (res.status === 200 && res.data.data) {
                    const webhook = res.data.data;
                    setWebhookData(webhook);
                    
                    // Set form values
                    setValue("webhookName", webhook.webhookName);
                    setValue("url", webhook.url);
                    setValue("secretKey", webhook.secretKey);
                    setValue("secretValue", webhook.secretValue);
                    setValue("version", webhook.version ?? "v1");
                    setIncludeTestData(Boolean(webhook.includeTestData));
                }
            } catch (error) {
                console.error("Error fetching webhook data:", error);
                NotificationManager.error("Error loading webhook data");
            } finally {
                setIsLoading(false)
            }
        };

        void fetchWebhookData();
    }, [id, setValue]);

 const handleCancelEdit = (): void => {
    setValue('webhookName', webhookData?.webhookName ?? '');
    setIsEditing(false);
  };
    const onSubmit = async (data: EditWebhookFormInputs): Promise<void> => {

        data.id = id;
        data.updatedBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        data.isActive = 1;
        data.isDeleted = 0;
        data.includeTestData = includeTestData;
        console.log(data);
        setIsLoading(true)
        await updateWebhookConfig(data)
            .then(
                (res: EditApiResponse) => {
                    if (res.status === 200 ) {
                        if(res.data.result === 1) {
                            NotificationManager.success("Webhook updated successfully")
                            refreshPage()
                        } else {
                                NotificationManager.error("Unknown error has occurred")
                        }
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleEditWebhook = ():void => {
        setIsEditing(true);
    }

    return (
        <React.Fragment>
            {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <form onSubmit={(e) => {e.preventDefault(); void handleSubmit(onSubmit)(e);}}>
                        <div className="px-[16px] pt-[10px]">
                            <div className="grid">
                                <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                                    <div >
                                        <Controller
                                            name="webhookName"
                                            control={control}
                                            defaultValue={webhookData?.webhookName}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    label="Webhook Name*"
                                                    autoComplete="off"
                                                    placeholder={WEBHOOK_NAME}
                                                    // value={field.value}
                                                    error={Boolean(errors.webhookName)}
                                                    helperText={errors.webhookName?.message}
                                                    InputProps={{
                                                        
                                                        placeholder: `${WEBHOOK_NAME}`,
                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                {!isEditing ? (
                                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditWebhook}>
                                                                                    <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" />
                                                                                </div>
                                                                                ) : (
                                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleCancelEdit}>
                                                                                    <HugeiconsIcon
                                                                                    icon={Cancel01Icon}
                                                                                    size={20}
                                                                                    color="#3a3a3a"
                                                                                    strokeWidth={0.2}
                                                                                    />
                                                                                </div>
                                                                                )}
                                                                            </InputAdornment>
                                                                            ),                                                   
                                                    }}
                                                    sx={{
                                                        '& input': {
                                                            textAlign: 'center',
                                                        },
                                                        '& label': {
                                                            textAlign: 'center',
                                                        },
                                                    }}
                                                    disabled={!isEditing}
                                                />
                                            )}
                                        />
                                    </div> 
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="url"
                                        control={control}
                                        defaultValue={webhookData?.url}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            label="Webhook URL*"
                                            {...field}
                                            fullWidth
                                            autoComplete="off"
                                            
                                            error={!!errors.url} // Set error state based on form validation
                                            placeholder={WEBHOOK_URL}
                                            />
                                            {errors.url && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.url?.message} 
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="secretKey"
                                        control={control}
                                        defaultValue={webhookData?.secretKey}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            {...field}
                                            label="Secret Key"
                                            fullWidth
                                            autoComplete="off"
                                            
                                            error={!!errors.secretKey} // Set error state based on form validation
                                            placeholder={WEBHOOK_SECRET}
                                            />
                                            {errors.secretKey && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.secretKey?.message} {/* Show the error message */}
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="secretValue"
                                        control={control}
                                        defaultValue={webhookData?.secretValue}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            {...field}
                                            label="Secret Value"
                                            fullWidth
                                            autoComplete="off"
                                            
                                            error={!!errors.secretValue} // Set error state based on form validation
                                            placeholder={WEBHOOK_SECRET_VALUE}
                                            />
                                            {errors.secretValue && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.secretValue?.message} {/* Show the error message */}
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="version"
                                        control={control}
                                        defaultValue={webhookData?.version ?? "v1"}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            {...field}
                                            select
                                            fullWidth
                                            label="Version*"
                                            error={!!errors.version}
                                            >
                                                <MenuItem value="v1">v1</MenuItem>
                                                <MenuItem value="v2">v2</MenuItem>
                                            </TextField>
                                            {errors.version && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.version?.message}
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                                <div className="mb-[30px]">
                                    <div className="flex items-center whitespace-nowrap">
                                        <input
                                            type="checkbox"
                                            id="includeTestDataCheckbox"
                                            disabled={isLoading}
                                            checked={includeTestData}
                                            onChange={(e) => setIncludeTestData(e.target.checked)}
                                            className="mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                        />
                                        <label
                                            htmlFor="includeTestDataCheckbox"
                                            className={`mr-1 font-medium text-14 ${
                                                isLoading
                                                    ? 'text-[#9ca3af] cursor-not-allowed'
                                                    : 'text-[#3a3a3a] cursor-pointer'
                                            }`}
                                        >
                                            Include Test Data
                                        </label>
                                    </div>
                                </div>
                                {Boolean(version) && Boolean(VERSION_PAYLOADS[version]) && (
                                    <div className="mb-[30px]">
                                        <label className="block mb-1 text-14 font-medium text-[#3a3a3a]">
                                            {version.toUpperCase()} Payload
                                        </label>
                                        <pre className="bg-[#1e1e2e] text-white rounded p-3 text-13 overflow-auto whitespace-pre-wrap">
                                            {VERSION_PAYLOADS[version]}
                                        </pre>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                            <div className="w-full relative col-span-3">
                                <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                            </div>
                            <div className="w-full relative col-span-3">
                                <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading || !checkEventPermission('WEBHOOKS_UPDATE')}>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                            </div>
                        </div>
                    </form>
            }
        </React.Fragment>

    )
}

export default EditWebhookForm